class LocalStorageService {
  constructor() {
    this.prefix = 'AKA_'; // Префикс для всех ключей
  }
  // Основные методы
  /*
    access_token,
    refresh_token,
  */
  set(key, value) {
    try {
      const serializedValue = JSON.stringify(value);
      localStorage.setItem(this.getKey(key), serializedValue);
      return true;
    } catch (error) {
      console.error('LocalStorage set error:', error);
      return false;
    }
  }

  get(key) {
    try {
      const value = localStorage.getItem(this.getKey(key));
      return value ? JSON.parse(value) : null;
    } catch (error) {
      console.error('LocalStorage get error:', error);
      return null;
    }
  }

  remove(key) {
    try {
      localStorage.removeItem(this.getKey(key));
      return true;
    } catch (error) {
      console.error('LocalStorage remove error:', error);
      return false;
    }
  }

  clear() {
    try {
      // Удаляем только ключи с нашим префиксом
      Object.keys(localStorage).forEach(key => {
        if (key.startsWith(this.prefix)) {
          localStorage.removeItem(key);
        }
      });
      return true;
    } catch (error) {
      console.error('LocalStorage clear error:', error);
      return false;
    }
  }

  // Вспомогательные методы
  getKey(key) {
    return `${this.prefix}${key}`;
  }
}

export const localStorageService = new LocalStorageService();